import React from 'react';

import './input.less';

export const Input = (props) => {
    return (
        <input
            className="input-field"
            type="number"
			{...props}
            required
        />
    );
}



// WEBPACK FOOTER //
// ./src/react/views/generic/Input.jsx